import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "right-handler" }
const _hoisted_2 = { class: "menu-item" }
const _hoisted_3 = { class: "theme-list" }
const _hoisted_4 = { class: "theme-item-content" }
const _hoisted_5 = { class: "colors" }
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore, useSnapshotStore } from '@/store'
import { PRESET_THEMES } from '@/configs/theme'
import useScreening from '@/hooks/useScreening'
import useSlideTheme from '@/hooks/useSlideTheme'
import {
  ApiApp,
  AppStore,
  Export,
  TextRotationNone,
  TextRotationDown,
  Market,
  Home,
  Tag
} from '@icon-park/vue-next'

export default /*@__PURE__*/_defineComponent({
  __name: 'HorizontalItem',
  setup(__props) {

const mainStore = useMainStore()
const { creatingElement, editorAreaFocus } = storeToRefs(mainStore)
const {
  applyPresetThemeToSingleSlide,
  applyPresetThemeToAllSlides,
} = useSlideTheme()

const { enterScreening, enterScreeningFromStart } = useScreening()

const setDialogForExport = mainStore.setDialogForExport

// 点击一键生成
const OneGeneration = () => {
  // 清除编辑区选中
  mainStore.setActiveElementIdList([])
  if (editorAreaFocus.value) mainStore.setEditorareaFocus(false)
  window.parent.postMessage({action: 'OneClickGeneration'}, '*')
}





return (_ctx: any,_cache: any) => {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_IconPpt = _resolveComponent("IconPpt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dropdown, { trigger: ['click'] }, {
      overlay: _withCtx(() => [
        _createVNode(_component_Menu, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRESET_THEMES), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "theme-item",
                  key: index,
                  style: _normalizeStyle({
                  backgroundColor: item.background,
                  fontFamily: item.fontname,
                })
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "text",
                      style: _normalizeStyle({ color: item.fontColor })
                    }, "文字 Aa", 4),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.colors, (color, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "color-block",
                          key: index,
                          style: _normalizeStyle({ backgroundColor: color})
                        }, null, 4))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: ($event: any) => (_unref(applyPresetThemeToSingleSlide)(item))
                      }, "应用", 8, _hoisted_7),
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: ($event: any) => (_unref(applyPresetThemeToAllSlides)(item))
                      }, "应用全局", 8, _hoisted_8)
                    ])
                  ])
                ], 4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(AppStore)),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text showOrHideSpan" }, "主题", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_Menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_MenuItem, null, {
              default: _withCtx(() => [
                _createElementVNode("div", { onClick: OneGeneration }, [
                  _createVNode(_unref(Market)),
                  _cache[4] || (_cache[4] = _createElementVNode("span", {
                    class: "text",
                    style: {"margin-left":"6px"}
                  }, "一键生成", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_MenuItem, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(enterScreeningFromStart) && _unref(enterScreeningFromStart)(...args)))
                }, [
                  _createVNode(_component_IconPpt),
                  _cache[5] || (_cache[5] = _createElementVNode("span", {
                    class: "text",
                    style: {"margin-left":"6px"}
                  }, "从头开始演示", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_MenuItem, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(enterScreening) && _unref(enterScreening)(...args)))
                }, [
                  _createVNode(_component_IconPpt),
                  _cache[6] || (_cache[6] = _createElementVNode("span", {
                    class: "text",
                    style: {"margin-left":"6px"}
                  }, "从当前页开始", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_MenuItem, null, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setDialogForExport)('pptx')))
                }, [
                  _createVNode(_unref(Export)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", {
                    class: "text",
                    style: {"margin-left":"6px"}
                  }, "导出", -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "menu-item" }, [
          _createElementVNode("span", { class: "text" }, "More...")
        ], -1))
      ]),
      _: 1
    })
  ]))
}
}

})